/**
 * Carrega o dataset do financeiro gerencial uma vez por tela e separa
 * carregando / erro / dado (Task 16). Mesmo papel do `RmaBoundary`: nenhuma
 * tela do Financeiro repete essa lógica nem confunde erro de carga com "tudo
 * conciliado" / "margem zero".
 *
 * Migrado para `.tsx`/JSX real (Cluster E — Financeiro & Sistema, redesign
 * por perfil; ver `docs/architecture/ADR-0011-*.md`): troca mecânica de
 * sintaxe (`createElement` → JSX), sem nenhuma mudança de comportamento —
 * este componente só delega para `StatusPanel`, não tem markup próprio para
 * reforçar com ícone.
 */
// Import explícito de `React` — ver o mesmo comentário em `KpiCard.tsx`
// (necessário para `tsx --test`, o motor de `npm test`).
import React, { type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useFinancialDataset } from "../queries.js";
import type { FinancialDataset } from "../financial/dataset.js";

export interface FinancialBoundaryProps {
  children: (dataset: FinancialDataset) => ReactElement;
}

export function FinancialBoundary({ children }: FinancialBoundaryProps): ReactElement {
  const query = useFinancialDataset();
  if (query.isPending) {
    return <StatusPanel kind="loading" title="Carregando o financeiro gerencial…" />;
  }
  if (query.error) {
    return <StatusPanel kind="error" title="Não foi possível carregar o financeiro" detail={errorDetail(query.error)} />;
  }
  if (!query.data) {
    return <StatusPanel kind="empty" title="Nenhum dado financeiro retornado pela API da Plataforma" />;
  }
  return children(query.data);
}
